import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: {},
  error: undefined,
  result: undefined,
  isValid: false,
};

const setData = (store, data) => {
  store.setState((state) => {
    state.modulo.socios.info.data = { ...data };
  });
};

const get = async (store, id, params = {}) => {
  store.setState((state) => {
    state.modulo.socios.info.busy = true;
  });

  try {
    const response = await Http.get(`api/socios/${id}`, { params });

    store.setState((state) => {
      state.modulo.socios.info.busy = false;
      state.modulo.socios.info.data = response.data;
    });

    return response.data;
  } catch (error) {
    store.setState((state) => {
      state.modulo.socios.info.busy = false;
      state.modulo.socios.info.error = error.data || error;
    });
  }
};

const resetError = (store) => (state) => {
  state.modulo.socios.info.error = undefined;
};

const reset = (store) => (state) => {
  state.modulo.socios.info = { ...initialState };
};

const actions = {
  setData,
  get,
  reset,
  resetError,
};

const SociosDeNegocioInfoStore = {
  state: () => initialState,
  actions,
};

export default SociosDeNegocioInfoStore;
